var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 645,
    height: 635,
    viewBox: "0 0 645 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 365.3V487C24.7 503.4 33.4 518.5 47.6 526.6L153 587.4L281.3 513.3V365.2L153 291.2L24.7 365.3Z",
    fill: "#F6A51E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.9 365.3V487C619.9 503.4 611.2 518.5 597 526.6L491.6 587.4L363.3 513.3V365.2L491.6 291.1L619.9 365.3Z",
    fill: "#F6A51E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.7 587.4L591.9 529.6L610.8 508.1L363.4 365.3V513.4L491.7 587.4Z",
    fill: "#FED007"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M491.7 302.8L610 371.1V487C610 499.7 603.1 511.6 592.1 518L491.7 576L373.4 507.7V371L491.7 302.8ZM491.7 291.2L363.4 365.3V513.4L491.7 587.5L597.1 526.7C611.3 518.5 620 503.4 620 487.1V365.4L491.7 291.2Z",
    fill: "#F6A51E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153 587.4L58.2 532.8L50.6 528.3L33.7 508.2L281.2 365.3V513.4L153 587.4Z",
    fill: "#FED007"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153 302.8L271.3 371.1V507.7L153 575.9L52.6 517.9C41.6 511.5 34.7 499.7 34.7 486.9V371L153 302.8ZM153 291.2L24.7 365.3V487C24.7 503.4 33.4 518.5 47.6 526.6L153 587.4L281.3 513.3V365.2L153 291.2Z",
    fill: "#F6A51E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600098 291.7V158C0.600098 141.6 9.3001 126.5 23.5001 118.4L139.3 51.6L278 131.7V291.8L139.3 371.9L0.600098 291.7Z",
    fill: "#F6A51E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M644 291.7V158C644 141.6 635.3 126.5 621.1 118.4L505.3 51.6L366.6 131.7V291.8L505.3 371.9L644 291.7Z",
    fill: "#9E441B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M505.4 51.5L613.7 114.1L634.2 137.3L366.7 291.7V131.6L505.4 51.5Z",
    fill: "#F6A51E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M505.4 63.1L616.2 127.1C627.2 133.5 634.1 145.3 634.1 158.1V286L505.4 360.3L376.7 286V137.4L505.4 63.1ZM505.4 51.5L366.7 131.6V291.7L505.4 371.8L644.1 291.7V158C644.1 141.6 635.4 126.5 621.2 118.4L505.4 51.5Z",
    fill: "#F6A51E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 51.5L36.8 110.7L28.6 115.4L10.3 137.2L277.9 291.7V131.6L139.2 51.5Z",
    fill: "#FEF6FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 63.1L267.9 137.4V286L139.2 360.3L10.5 286V158C10.5 145.3 17.4 133.4 28.4 127L139.2 63.1ZM139.2 51.5L23.4 118.3C9.2 126.5 0.5 141.6 0.5 157.9V291.6L139.2 371.7L277.9 291.6V131.5L139.2 51.5Z",
    fill: "#F6A51E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 475.8V158.9L322.3 0.400024L596.8 158.9V475.8L322.3 634.3L47.8 475.8Z",
    fill: "#F6A51E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 628.9L591 472.4L547.9 447.5L342.4 566.2C330 573.3 322.4 586.5 322.4 600.8L322.3 628.9Z",
    fill: "#9E441B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 475.8L322.3 634.3V600.8C322.3 586.5 314.7 573.3 302.3 566.2L116.7 459.1C104.3 452 89.1 452 76.8 459.1L47.8 475.8Z",
    fill: "#FED007"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 33.9V3.90002L52 161.3L76.8 175.6C89.2 182.7 104.4 182.7 116.7 175.6L302.3 68.5C314.7 61.3 322.3 48.2 322.3 33.9Z",
    fill: "#FEF6FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M593.7 474L592.7 161.3L567.9 175.6C555.5 182.7 547.9 195.9 547.9 210.2V447.5L593.7 474Z",
    fill: "#9E441B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M499.1 197.5L371.5 123.8C356.6 115.2 339.6 110.6 322.4 110.6C305.2 110.6 288.2 115.2 273.3 123.8L145.7 197.5C135.7 203.3 129.5 214 129.5 225.5V297C129.5 322.6 140 347.1 158.3 364.8V370C158.3 406.5 177.9 440.5 209.4 458.7L322.4 524L435.4 458.7C467.8 440 485.9 406.7 486.5 364.8C504.9 347 515.3 322.6 515.3 297V225.5C515.3 214 509.1 203.3 499.1 197.5Z",
    fill: "#1C1128"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 323.3L167.3 236.1V297C167.3 317.1 178 335.7 195.4 345.7L322.2 418.9L449 345.7C466.4 335.6 477.1 317.1 477.1 297V236.1L322.3 323.3Z",
    fill: "#342A44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 419L196.2 346.2V370.1C196.2 393.2 208.4 414.4 228.3 425.9L322.3 480.2L416.3 425.9C436.2 414.4 448.4 393.2 448.4 362.9V346.2L322.3 419Z",
    fill: "#342A44"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M467.3 253.3V297.1C467.3 313.6 458.4 328.9 444.2 337.2L443.5 337.6L438.5 340.5V346.3V363C438.5 388.3 429.1 407.1 411.4 417.3L322.4 468.7L233.4 417.3C216.7 407.7 206.3 389.6 206.3 370.2V346.3V340.5L201.3 337.6L200.6 337.2C186.3 329 177.5 313.6 177.5 297.1V253.3L317.6 332.1L322.5 334.9L327.4 332.1L467.3 253.3ZM477.3 236.2L322.3 323.4L167.3 236.2V297.1C167.3 317.2 178 335.8 195.4 345.8L196.1 346.2V370.1C196.1 393.2 208.3 414.4 228.2 425.9L322.2 480.2L416.2 425.9C436.1 414.4 448.3 393.2 448.3 362.9V346.2L449 345.8C466.4 335.7 477.1 317.2 477.1 297.1V236.2H477.3Z",
    fill: "#443B59"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.8 215.3L322.3 291.2L453.8 215.3L352.4 156.8C333.7 146 310.8 146 292.1 156.8L190.8 215.3Z",
    fill: "#698445"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M352.5 156.7C343.2 151.3 332.8 148.6 322.4 148.6V291.2L453.9 215.3L352.5 156.7Z",
    fill: "#1F4927"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 236.2L196.1 218.3L322.3 291.2L448.5 218.3L322.3 236.2Z",
    fill: "#143321"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 158.7C331.1 158.7 339.8 161 347.4 165.4L433.8 215.3L322.3 279.7L210.8 215.3L297.2 165.4C304.8 161 313.5 158.7 322.3 158.7ZM322.3 148.7C311.9 148.7 301.5 151.4 292.2 156.8L190.8 215.3L322.3 291.2L453.8 215.3L352.4 156.8C343.1 151.4 332.7 148.7 322.3 148.7Z",
    fill: "#2B5E36"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 11.9L586.8 164.6V470L322.3 622.7L57.8 470V164.6L322.3 11.9ZM322.3 0.400024L47.8 158.9V475.9L322.3 634.4L596.8 475.9V158.9L322.3 0.400024Z",
    fill: "#F6A51E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1001 135.7L150.4 168.2C160.6 161.8 165.3 155.7 179.1 146.8L125.1 115.3L94.1001 135.7Z",
    fill: "#F6A51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold1);
export default __webpack_public_path__ + "static/media/gold-1.dbf30bb06579441db83a84359c9f7f7c.svg";
export { ForwardRef as ReactComponent };